import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import moment from "moment";
import { plan2dItemText } from "variables/MBM/geb";
import Slider, { SliderThumb } from '@mui/material/Slider';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PropTypes from 'prop-types';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';

const useStyles = makeStyles((theme) => ({
    planicon: {
        display: 'block',
        position: 'absolute',
        cursor: 'pointer',
        background: '#ffffffd6',
        borderRadius: 10,
    },
}));

// const PlanMenuButton = styled.div`
//     width:30px;
//     height:30px;
//     padding-top: 3px;
//     padding-left: 3px;
//     margin-right: 5px;
//     cursor: pointer;
//     border: 1px solid;
//     border-color: #8080804d;
//     border-radius: 4px;
// `;

const PlanMenuButton = styled(Button)(({ theme }) => ({
    width: '30px',
    height: '30px',
    padding: '0px',
    marginLeft: '30px',
    cursor: 'pointer',
    border: '1px solid',
    borderColor: '#8080804d',
    borderRadius: '4px',
    minWidth: '30px',
    color: '#91C73C'
}));

const ClockSlider = styled(Slider)(({ theme }) => ({
    color: theme.palette.mode === 'dark' ? '#0a84ff' : '#9798A0',
    height: 5,
    padding: '15px 0',
    width: '60%',
    margin: '15px 0 15px 10%',
    '& .MuiSlider-thumb': {
        height: 20,
        width: 20,
        backgroundColor: '#fff',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&::before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        fontSize: 12,
        fontWeight: 'normal',
        top: -6,
        backgroundColor: 'unset',
        color: theme.palette.text.primary,
        '&::before': {
            display: 'none',
        },
        '& *': {
            background: 'transparent',
            color: theme.palette.mode === 'dark' ? '#fff' : '#000',
        },
    },
    '& .MuiSlider-track': {
        border: 'none',
        height: 5,
    },
    '& .MuiSlider-rail': {
        opacity: 0.5,
        boxShadow: 'inset 0px 0px 4px -2px #000',
        backgroundColor: '#d0d0d0',
    },
}));

function ThumbComponent(props) {
    const { children, ...other } = props;
    return (
        <SliderThumb {...other}>
            {children}
            <AccessTimeIcon></AccessTimeIcon>
        </SliderThumb>
    );
}

ThumbComponent.propTypes = {
    children: PropTypes.node,
};

export function Plan2dSlider(props) {
    const classes = useStyles();
    const [planSliderValue, setPlanSliderValue] = useState(167);
    const [buttonStatus, setButtonStatus] = useState("pause");
    const [refresh, setRefresh] = useState(false);
    const [timeoutfunc, setTimeoutfunc] = useState("");
    const { onClick, endDate, planDatatime, setPlandatatime, refreshPlan2DData, planrefreshdataLock } = props;

    const valuetext = (value) => {
        // let val = moment(endDate).add(-1 * (167 - value), 'h').format("DD/MM/YYYY HH:mm");
        let val = moment(endDate).add(-1 * (167 - value), 'h').format("LLLL");
        // console.log(val);
        return val;
    }

    const handleSliderChange = (event, newValue) => {
        setPlanSliderValue(newValue);
    };

    const handleTimelineButtonClick = (event) => {
        if (buttonStatus === 'pause') {
            setButtonStatus('play');
            if (planSliderValue == 167)
                setPlanSliderValue(0);
        }
        else
            setButtonStatus('pause');
    }

    useEffect(() => {
        setPlandatatime(moment(endDate).add(-1 * (167 - planSliderValue), 'h'));
    }, [planSliderValue]);

    useEffect(() => {
        if (buttonStatus === 'play')
            setRefresh(!refresh);
    }, [buttonStatus]);

    useEffect(() => {
        if (timeoutfunc) {
            clearTimeout(timeoutfunc);
            setTimeoutfunc();
        }
        let planSliderValueTmp = planSliderValue;
        if (buttonStatus === 'play' && planSliderValueTmp < 167) {
            planSliderValueTmp = planSliderValueTmp + 1;
            setPlanSliderValue(planSliderValueTmp);
            setTimeoutfunc(setTimeout(() => {
                if (buttonStatus === 'play')
                    setRefresh(!refresh);
            }, 1000));
        }
        else {
            setButtonStatus('pause');
        }
    }, [refresh]);

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <ClockSlider
                aria-label="Restricted values"
                value={typeof planSliderValue === 'number' ? planSliderValue : 167}
                getAriaValueText={valuetext}
                valueLabelFormat={valuetext}
                step={1}
                min={0}
                max={167}
                valueLabelDisplay="on"
                onChange={handleSliderChange}
                slots={{ thumb: ThumbComponent }}
            />
            <PlanMenuButton
                color={"success"}
                onClick={handleTimelineButtonClick}
            >
                {
                    buttonStatus === 'pause' ?
                        <PlayArrowIcon />
                        :
                        <PauseIcon />
                }

            </PlanMenuButton>
            {/* <PlanMenuButton
                color={"success"}
                onClick={refreshPlan2DData}
                disabled={planrefreshdataLock}
            >
                <RefreshIcon/>
            </PlanMenuButton> */}
        </div>
    );
}
